import { render } from "./AssemblyFlex.vue?vue&type=template&id=8088bd3c"
import script from "./AssemblyFlex.vue?vue&type=script&lang=js"
export * from "./AssemblyFlex.vue?vue&type=script&lang=js"

import "./AssemblyFlex.vue?vue&type=style&index=0&id=8088bd3c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__